import { PropsWithChildren } from 'react'
import { ComponentUtils } from '@/utils/design-system/componentUtils'
import Subtitle from '../typography/Subtitle'

type TableHeaderProps = {
  rightSide?: JSX.Element
  leftSide?: JSX.Element
}

const TableHeader = ({ children, rightSide, leftSide }: PropsWithChildren<TableHeaderProps>) => {
  const getDirectionClassName = () => {
    const hasRightSide = !!rightSide
    const hasLeftSide = !!leftSide
    switch (true) {
      case hasLeftSide && hasRightSide:
        return 'justify-between'
      case hasLeftSide && !hasRightSide:
        return 'justify-start'
      case !hasLeftSide && hasRightSide:
        return 'justify-end'
      default:
        return ''
    }
  }

  return (
    <>
      <Subtitle styleClass={ComponentUtils.cn('flex w-full items-end', getDirectionClassName())}>
        {leftSide && <div>{leftSide}</div>}
        {rightSide && <div>{rightSide}</div>}
      </Subtitle>
      <div className="divider mt-2"></div>
      <div className="h-full w-full bg-base-100 pb-6">{children}</div>
    </>
  )
}

export default TableHeader
